<div class="developer-content">
  <div class="developer-bar">
    <a class="developer-bar-item" href="#skills-content">Skills</a>
    <a class="developer-bar-item" href="#timeline-content">Career Timeline</a>
    <a class="developer-bar-item" href="#project-content">Projects</a>
    <a class="developer-bar-item" href="#education-content">Education</a>
    <a class="developer-bar-item" (click)="scrollToBottom()">Contact Me</a>
  </div>
  <app-skills></app-skills>
  <app-career></app-career>
  <app-projects></app-projects>
  <app-education></app-education>
  <!-- <app-literature></app-literature> -->
  <!-- <app-courses></app-courses> -->
</div>
